import { FormattedMessage } from "react-intl";

import { Box, CircularProgress, Typography } from "@material-ui/core";

import { useStyles } from "../../../shared/styles/useStyles";
import { CorrespondenceStatisticsForm } from "./CorrespondenceStatisticsForm";
import { CorrespondenceStatisticsTable } from "./CorrespondenceStatisticsTable";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducers/rootReducer";
import { FC, useState } from "react";
import { ICorrespondence } from "../../../interfaces/Correspondence";
import moment from "moment";
import { IstatisticalCorrespondence } from "../../../redux/types/typeReport";
import { getCorrespondenceStadistics } from "../../../services/firebase/correspondenceReport";

interface Props {
  module: { type: string; rol: string };
}

export const CorrespondenceStatistics: FC<Props> = ({ module }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state: AppState) => state.auth);
  const [results, setResults] = useState<ICorrespondence[]>([]);

  const onSearch = (data: IstatisticalCorrespondence) => {
    try {
      setLoading(true);
      if (user && user.idEntity) {
        getCorrespondenceStadistics(user.idEntity, data).then((response) => {
          if (response.ok) {
            setResults(response.data);
          }
          setLoading(false);
        });
      }
    } catch (error) {
      setLoading(false);
      console.log(" Ocurrio un error: ", error);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="body1" className={classes.title}>
        <FormattedMessage id="CorrespondenceStatistics" />
      </Typography>

      <CorrespondenceStatisticsForm onSearch={onSearch} module={module} />

      {loading ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <CircularProgress style={{ display: "flex", alignSelf: "center" }} />
        </div>
      ) : (
        <CorrespondenceStatisticsTable correspondences={results} />
      )}
    </Box>
  );
};
